import { queryOptions } from "@tanstack/react-query";

import { api } from "@/api/api";
import type { PublicPlacementsOutputDto } from "@/types/codegen";
import type { BannersPlacementSlug } from "@/types/enums";

export const bannersPlacementQueryOptions = (slug: BannersPlacementSlug) =>
  queryOptions({
    queryKey: ["placements", slug],
    queryFn: ({ signal }) =>
      api.get<PublicPlacementsOutputDto>("/placements", {
        signal,
        params: { slugs: [slug] },
      }),
    select: (response) =>
      response.data.data.placements.find(
        (placement) => placement.slug === slug,
      ),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
